var map = {
	"./composer": 999,
	"./composer.js": 999,
	"./constructor": 1003,
	"./constructor.js": 1003,
	"./dumper": 1008,
	"./dumper.js": 1008,
	"./emitter": 1009,
	"./emitter.js": 1009,
	"./errors": 1001,
	"./errors.js": 1001,
	"./events": 1000,
	"./events.js": 1000,
	"./loader": 1013,
	"./loader.js": 1013,
	"./nodes": 1002,
	"./nodes.js": 1002,
	"./parser": 1017,
	"./parser.js": 1017,
	"./reader": 1014,
	"./reader.js": 1014,
	"./representer": 1011,
	"./representer.js": 1011,
	"./resolver": 1012,
	"./resolver.js": 1012,
	"./scanner": 1015,
	"./scanner.js": 1015,
	"./serializer": 1010,
	"./serializer.js": 1010,
	"./tokens": 1016,
	"./tokens.js": 1016,
	"./util": 1004,
	"./util.js": 1004,
	"./yaml": 998,
	"./yaml.js": 998
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1018;



//////////////////
// WEBPACK FOOTER
// ./~/yaml-js/lib ^\.\/.*$
// module id = 1018
// module chunks = 0